import React, { useEffect } from "react";
import { useState, useRef } from "react";
import Navbar from "../Navbar";
import Footer from "../Footer";
import { config } from "../api/api";
import Cookies from 'js-cookie';
import { useLocation } from "react-router-dom";
import { parse } from "date-fns";
import { useTranslation } from "react-i18next";
const MotorInsQuoteSummary = () => {
  // const [isClicked, setIsClicked] = useState(false);

  const lnstr = Cookies.get('langData') ? Cookies.get('langData') : 'en';
  
    const { t } = useTranslation();

  const [loading, setLoading] = useState(true);
  const [activeButton, setActiveButton] = useState(-1);
  const [isClickedWhatsapp, setIsClickedWhatsapp] = useState(true);
  const [errors, setErrors] = useState({});
  const [details, setDetails] = useState(null);

  const [sameAsMobile, setSameAsMobile] = useState(false);
  // const [isChecked, setIsChecked] = useState(false);

  const base_url = config.baseURL;
  const [vendorKey, setVendorkey] = useState("");
  // const vendor_key =
  //   "yeflesxnwar1xh31o6pg4ww9fr03ohn74u4h6oy0xx4qpzot0aqbhwlhbiv55k0qf1bls12v7zrlhriuu77wcytijxdzvfrfnxlhq68y30eiy59ok01iyn1xzyangrew9w19cchvd62js5164j4bmfcauj3vc7qkpqkjdl7hdpzxc2xzoq35ehuq3gzybhh1rc3v6tr5slr2ivv958ixq35k5meh3626v3g9sckyp267o8vup7kd72ntp9udknjz";

  const insuredMobileNoRef = useRef(null);
  const insuredEmailIdRef = useRef(null);
  const insuredWhatsappRef = useRef(null);

    const [hoveredCovers, setHoveredCovers] = useState([]);   // store hover covers
    const [showTooltip, setShowTooltip] = useState(false);    // toggle tooltip
    const [tooltipPos, setTooltipPos] = useState({ x: 0, y: 0 });
    const [allow,setAllow] = useState(false);

       useEffect(()=>{
               const getBasicInfo=sessionStorage.getItem("motorBasicDetails");
               if(!getBasicInfo){
                  window.location.href="/motor-insurance-page"
               }
               else{
                setAllow(true);
               }
            },[])
  const handleClick = (buttonId) => {
    debugger
    setActiveButton(buttonId);


    const prodID = formData.prodId;
    const match = prodID.match(/^(\d+)/); // for extract 0502
    if (match) {
      setFormData({ ...formData, prodId: match[1] });
    }

    setFormData({
      ...formData,
      selectedPlan:buttonId,
      packageId: details.packageDetails[buttonId].$.id,
      planSelection: details.packageDetails[buttonId].planSelection,
      premiumAmount: details.packageDetails[buttonId].premiumAmt,
      obtainedCover: details.packageDetails[buttonId].obtainedCvr,
    });
  };

  const handleClickSingleOption=(buttonId,plan)=>{
    debugger
 setActiveButton(buttonId);


 
    const prodID = formData.prodId;
    const match = prodID.match(/^(\d+)/); // for extract 0502
    if (match) {
      setFormData({ ...formData, prodId: match[1] });
    }

    setFormData({
      ...formData,
      selectedPlan:buttonId,
      packageId: match[1],
      planSelection: plan.planSelection,
      premiumAmount: plan.premiumAmt,
      obtainedCover: plan.obtainedCvr || plan.packageDetails.obtainedCvr,
    });

  }

  const handleWhatsapp = (e) => {
    setIsClickedWhatsapp(e.target.checked);
    if (isClickedWhatsapp === true) {
      setFormData((prev) => ({
        ...prev,

        insuredWhatsapp: "",
      }));
      setSameAsMobile(false);
    }
  };

  const [formData, setFormData] = useState({
    prodId: "",
    packageId: "",
    planSelection: "",
    premiumAmount: "",
    obtainedCover: "",
    quoteNo: "",
    srcBusId: "SJET",
    insuredMobileNo: "",
    insuredWhatsapp: "",
    insuredEmailId: "",
  });

  const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

  const handleChange = (e) => {
    const { name, value } = e.target;
    const trimValue = value.trimStart();

    const numberRegex = /^[0-9]*$/;

    if (name === "insuredMobileNo") {
      if (numberRegex.test(trimValue)) {
        setFormData({ ...formData, [name]: trimValue });
      }
      return;
    }
    if (name === "insuredWhatsapp") {
      if (numberRegex.test(trimValue)) {
        setFormData({ ...formData, [name]: trimValue });
      }
      return;
    }
    if (name === "insuredEmailId") {
      setFormData({ ...formData, [name]: trimValue });
      return;
    }
    // if (name === "checkBox") {
    //   setIsChecked(e.target.checked);
    //   return;
    // }
    else {
      setFormData({ ...formData, [name]: trimValue });
    }
  };

  const validationDetails = () => {
    let newErrors = {};

    if (!formData.insuredMobileNo) {
      newErrors.insuredMobileNo = "MobileNo is Required";
    }

    if (!formData.insuredWhatsapp) {
      newErrors.insuredWhatsapp = "Whatsapp is Required";
    }
    // if(sameAsMobile=== true){
    //    newErrors.insuredWhatsapp = "";
    // }

    if (emailChecked === true) {
      const email = formData.insuredEmailId.trim();
      if (!email) {
        newErrors.insuredEmailId = "Email Id is Required";
      } else if (!emailRegex.test(email)) {
        newErrors.insuredEmailId = "Enter valid Email Id";
      }
    }

    // if (!isChecked) {
    //   newErrors.checkBox = "accept is required";
    // }

    setErrors(newErrors);

    if (Object.keys(newErrors).length > 0) {
      const firstErrorField = Object.keys(newErrors)[0];
      switch (firstErrorField) {
        case "insuredMobileNo":
          insuredMobileNoRef.current.focus();
          break;
        case "insuredWhatsapp":
          insuredWhatsappRef.current.focus();
          break;
        case "insuredEmailId":
          insuredEmailIdRef.current.focus();
          break;
        default:
          break;
      }
      return false;
    }

    return Object.keys(newErrors).length === 0; // If no errors, return true
  };

  const handleValidation = (e) => {
    const { name } = e.target;
    if (formData[name]?.trim()) {
      setErrors((prev) => ({ ...prev, [name]: "" }));
    }
    if (name === "checkBox") {
      setErrors((prev) => ({ ...prev, [name]: "" }));
    }
  };

  //data from prev page

  const [mobileNoChecked, setMobileNoChecked] = useState(false);
  const [emailChecked, setEmailChecked] = useState(false);

  useEffect(() => {
    const createOrganization = async () => {
      try {
        const postvData = { organization_name: "Superjet" };

        const response = await fetch(base_url + "/create_organization", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(postvData),
        });
        const data = await response.json();
        setVendorkey(data.result[0].vendor_key);
      } catch (error) {
        console.error("Error posting data:", error);
      }
    };

    if (!vendorKey) {
      createOrganization();
    }
  }, [vendorKey, base_url]);

  
  const search_quote = async (payload) => {
    try {
      const response = await fetch(base_url + "/motor_search_quote", {
        method: "POST",
        headers: {
          "content-Type": "application/json",
          Authorization: "Bearer " + vendorKey,
        },
        body: JSON.stringify(payload),
      });

      if (!response.ok) throw new Error("API request failed");

      const data = await response.json();

      return data;
    } catch (error) {
      console.log("unable to fetch data", error);
    }
  };



  useEffect(() => {

    const  getQuoteDetails=async()=>{
     try {
    const quoteNoSession = sessionStorage.getItem("motorQuoteNo");
debugger
    if(quoteNoSession){

      const parseQuoteNo= JSON.parse(quoteNoSession);
    if (parseQuoteNo.quoteNo) {

        const quote_payload = {
                  civilId: "",
                  plateNo: "",
                  registrationMark: "",
                  srcBusId: "SJET",
                  txnTyp: "Q",
                  mobileNo: "",
                  policyNo: "",
                  quoteNo: parseQuoteNo.quoteNo,
                  searchTyp: "",
                  policy_type:"new"
                };

                const searchData2 = await search_quote(quote_payload);
                if (searchData2.message === "success") {
                  if (searchData2.result.effectiveDt) {

      setDetails(searchData2.result);
      const match = searchData2.result.prodId.match(/^(\d+)/);
      setFormData((prev) => ({
        ...prev,
        prodId: match ? match[1] : searchData2.result.prodId, // store "0502"
        insuredMobileNo: searchData2.result.insuredDetails.insuredMobileNo,
      }));

      if(searchData2.result.packageDetails.length>0){

      }else if(Object.keys(searchData2.result.packageDetails).length>0 || searchData2.result?.obtainedCvr){
        setFormData((prev)=>(
          {...prev,premiumAmount:searchData2.result.packageDetails.premiumAmt || searchData2.result?.premiumAmt,
          obtainedCover:searchData2.result?.packageDetails?.obtainedCvr ||  searchData2.result?.obtainedCvr }))
          setActiveButton(1);
      }
      console.log(searchData2.result, "check");

      setMobileNoChecked(true);
    }
  }
}
  }

  const motorComSession = sessionStorage.getItem("communicationDetails");
  debugger
  if(motorComSession){
    const parseMotorCom  =  JSON.parse(motorComSession);
    if(parseMotorCom){
      setFormData(parseMotorCom);
      setActiveButton(Number(parseMotorCom.selectedPlan));
    }
  }
  }
  catch(err){
    console.log(err);
  }
  finally{
    setLoading(false)
  }
}
if(vendorKey){
  getQuoteDetails();
}
  }, [vendorKey]);

  const handleMobileNo = (e) => {
    const checked = e.target.checked;
    setMobileNoChecked(checked);

    if (checked) {
      setFormData((prev) => ({
        ...prev,
        insuredMobileNo: details.insuredDetails.insuredMobileNo,
      }));
    } else {
      setFormData((prev) => ({
        ...prev,
        insuredMobileNo: "",
      }));
    }
  };

  const handleEmail = (e) => {
    setEmailChecked(e.target.checked);
  };

  // const prodID = formData.prodId;
  //       const match = prodID.match(/^(\d+)/);   // for extract 0502
  //       if(match){
  //        setFormData({...formData,prodId:match[1]})

  //       }

  const package_Details = async () => {
    try {
      const package_payload = {
        prodId: formData.prodId,
        packageId: formData.packageId,
        planSelection: formData.planSelection,
        premiumAmount: formData.premiumAmount,
        obtainedCover: formData.obtainedCover,
        quoteNo: details.transactionDetails.quoteNo || details.renewalQuoteNo,
        srcBusId: "SJET",
      };
      const response = await fetch(base_url + "/confirm_package_plan", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer" + vendorKey,
        },
        body: JSON.stringify(package_payload),
      });

      if (!response.ok) throw new Error("API request failed");
      const data = await response.json();

      return data;
    } catch (error) {
      console.log("unable to fetch data", error);
    }
  };


  const Communication_Details = async (Communication_payload) => {
    try {
      const response = await fetch(base_url + "/update_communication_prefer", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + vendorKey,
        },
        body: JSON.stringify(Communication_payload),
      });
      if (!response.ok) throw new Error("API request Failed");

      const data = await response.json();

      return data;
    } catch (error) {
      console.log("unable to fetch communication data", error);
    }
  };

  const payment_Details = async (payment_payload) => {
    try {
      const response = await fetch(base_url + "/motor_ins_payments", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + vendorKey,
        },
        body: JSON.stringify(payment_payload),
      });
      if (!response.ok) throw new Error("API request failed");
      const data = await response.json();

      // console.log(data,"paydata");

      return data;
    } catch (error) {
      console.log(error);
    }
  };


  const handlePay = async (e) => {
    e.preventDefault();
    try {
      if (!validationDetails()) return;


      setLoading(true);

       sessionStorage.setItem("communicationDetails",JSON.stringify(formData));

      if(details.packageDetails.length>0){
      const packageData = await package_Details();
      if (!packageData || packageData.result.status !== "Y") {
        console.error("Package data failed");
        return;
      }
      }

      const Communication_payload = {
        licenseNo: details.insuredDetails.insuredLicNo, // civil id
        quoteNo: details.transactionDetails.quoteNo || details.renewalQuoteNo,
        agentCode: "Agent1",
        emailId: formData.insuredEmailId,
        mobileCountry: "968",
        mobileNo: formData.insuredMobileNo,
        whatsappNo: formData.insuredWhatsapp,
      };



      const communicationData = await Communication_Details(
        Communication_payload
      );
      if (
        communicationData.message !== "success" ||
        communicationData.result.message !== "S"
      ) {
        console.error("Communication Data failed");
        return;
      }

      const payment_payload = {
        quoteNo: details.transactionDetails.quoteNo || details.renewalQuoteNo,
        amount: formData.premiumAmount,
      };

      const paymentData = await payment_Details(payment_payload);
      if (paymentData.message !== "success") {
        console.error("Payment details failed");
        return;
      }

      window.location.href = paymentData.result?.data;
    } catch (error) {
      console.error("Error in handlePay:", error);
    } finally {
      setLoading(false);
    }
  };

    

  const handleHoverObtainCvr = (e, obtCvr) => {
    const cover_details = obtCvr.split(/,(?!\d)/);
    setHoveredCovers(cover_details);

    // position tooltip near the icon
    const rect = e.target.getBoundingClientRect();
    setTooltipPos({
  x: rect.left,   // center X
  y: rect.bottom +10              // 10px above the element
});
    setShowTooltip(true);
  };

  const handleLeave = () => {
    setShowTooltip(false);
    setHoveredCovers([]);
  };
 

  return (
    <>
{   allow &&   
<>
<div className="header_section1">
        <Navbar />

        <div className="container-fluid bg-breadcrumb">
          <div className="container text-center py-5">
            <h3 className="abt-txt my-5">{t("Quote Summary")}</h3>
          </div>
        </div>
      </div>

      <div className="features_section">
        <div className="container  mt-3">
          {details && (
            <div className="row">
              <div className=" col-md-6 mt-3">
                <div className="border  rounded p-3">
                  <h3>{t("Vehicle")}</h3>
                  <div className=" border d-flex flex-wrap p-3 align-items-center justify-content-between mb-2">
                    <div className="p-0">
                      <h3 className=" p-0">
                        {details.vehicleDetails.make}{" "}
                        {details.vehicleDetails.model}
                      </h3>

                      <p className="m-0">{details.vehicleDetails.manuYear}</p>
                    </div>
                    <div className="">
                      <button className="btn btn-primary">
                        {details.vehicleDetails.vehRegNo}{" "}
                        {details.vehicleDetails.vehRegLOC}
                      </button>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-6">
                      <h5 className="p-0">{t("Chassis no.")}</h5>
                      <p>{details.vehicleDetails.chasisNo}</p>
                    </div>
                    <div className="col-md-6">
                      <h5 className="p-0">{t("Body Type")}</h5>
                      <p>{details.vehicleDetails.vehBody}</p>
                    </div>
                    <div className="col-md-6 ">
                      <h5 className="p-0">{t("Usage Type")}</h5>
                      <p>{details.vehicleDetails.usage}</p>
                    </div>
                  </div>
                </div>
                <div className="border  rounded p-3 mt-2">
                  <h3>{t("Insured")}</h3>

                  <div className="row">
                    <div className="col-md-12 ">
                      <h5 className="p-0">{t("Insured Name")}</h5>
                      <p>{details.insuredDetails.insureFullName}</p>
                    </div>
                    <div className="col-md-6 ">
                      <h5 className="p-0">{t("Civil id")}</h5>
                      <p> {details.insuredDetails.insuredLicNo}</p>
                    </div>
                    <div className="col-md-6">
                      <h5 className="p-0">{t("Age")}</h5>
                      <p>{details.insuredDetails.insuredAge}</p>
                    </div>
                  </div>
                </div>

                <div className="border  rounded p-3 mt-2">
                  <h3>{t("Communication Preference")}</h3>
                  <div>
                    <h5>{t("Your Communication Preference and Consent")}</h5>
                    <p>
                    {  lnstr=="en"?
                  `Please select how you'd like to receive policy documents
                      and communications. By choosing your preferred mode, you
                      consent to receiving documents and related updates
                      electronically. You can update these preferences anytime.
                      Preferred Communication Mode (I consent for receiving
                      policy documents, related updates and communications
                      electronically)`
                      :
                      `يرجى تحديد طريقة استلام وثائق السياسات والمراسلات. باختيارك الطريقة المُفضّلة، فإنك توافق على استلام الوثائق والتحديثات ذات الصلة إلكترونيًا. يمكنك تحديث هذه التفضيلات في أي وقت. طريقة الاتصال المُفضّلة (أوافق على استلام وثائق السياسات والتحديثات والمراسلات ذات الصلة إلكترونيًا).`}
                    </p>
                  </div>

                  <div className="row">
                    <div className="col-md-6 mt-2">
                      <label className="mb-0 mt-1 ">
                        <input
                          type="checkbox"
                          checked={mobileNoChecked}
                          onChange={handleMobileNo}
                        />{" "}
                        {t("Mobile Number")}
                        <span style={{ color: "red" }}>*</span>
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        name="insuredMobileNo"
                        value={formData?.insuredMobileNo}
                        onChange={handleChange}
                        // disabled={mobileNoChecked === false}
                        disabled={!mobileNoChecked}
                        ref={insuredMobileNoRef}
                        onBlur={handleValidation}
                      />
                      {errors.insuredMobileNo && (
                        <span style={{ color: "red", fontSize: "12px" }}>
                          {errors.insuredMobileNo}
                        </span>
                      )}
                    </div>

                    <div className="col-md-6  mt-2">
                      <div className="p-0 d-flex justify-content-between">
                        <label className="mb-0 mt-1 ">
                          <input
                            type="checkbox"
                            checked={isClickedWhatsapp}
                            onClick={handleWhatsapp}
                          />{" "}
                          {t("Whatsapp")}<span style={{ color: "red" }}>*</span>
                        </label>

                        {isClickedWhatsapp && (
                          <div className="p-0 d-flex justify-content-center align-items-center ">
                            <input
                              type="checkbox"
                              checked={sameAsMobile}
                              onChange={(e) => {
                                const checked = e.target.checked;
                                setSameAsMobile(checked);

                                if (checked) {
                                  setFormData({
                                    ...formData,
                                    insuredWhatsapp: formData.insuredMobileNo,
                                  });
                                  setErrors((prev) => ({
                                    ...prev,
                                    insuredWhatsapp: "",
                                  }));
                                } else {
                                  setFormData({
                                    ...formData,
                                    insuredWhatsapp: "",
                                  });
                                }
                              }}
                            />
                            <label
                              className="mb-0 ml-1"
                              style={{ fontSize: "8px" }}
                            >
                              {t("Same as mobile no.")}
                            </label>
                          </div>
                        )}
                      </div>
                      <input
                        type="text"
                        className="form-control"
                        name="insuredWhatsapp"
                        value={formData.insuredWhatsapp}
                        onChange={handleChange}
                        ref={insuredWhatsappRef}
                        onBlur={handleValidation}
                        disabled={!isClickedWhatsapp || sameAsMobile}
                      />
                      {errors.insuredWhatsapp && (
                        <span style={{ color: "red", fontSize: "12px" }}>
                          {errors.insuredWhatsapp}
                        </span>
                      )}
                    </div>
                    <div className="col-md-6 mt-2">
                      <label className="mb-0 mt-1 ">
                        {" "}
                        <input
                          type="checkbox"
                          checked={emailChecked}
                          onClick={handleEmail}
                        />{" "}
                        {t("Email")}
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        name="insuredEmailId"
                        ref={insuredEmailIdRef}
                        value={formData.insuredEmailId}
                        onChange={handleChange}
                        onBlur={handleValidation}
                        disabled={!emailChecked}
                      />
                      {errors.insuredEmailId && (
                        <span style={{ color: "red", fontSize: "12px" }}>
                          {errors.insuredEmailId}
                        </span>
                      )}
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-6  mt-3 ">
                <div className="border  rounded p-3">
                  <h3>{t('Quote')}</h3>

                  <div className="row">
                    <div className="col-md-12 mt-1">
                      <h5 className="p-0">{t("Quote no.")}</h5>
                      <p className="">
                        {details.transactionDetails.quoteNo ||
                          details.renewalQuoteNo}
                      </p>
                    </div>
                    <div className="col-md-6  mt-1">
                      <h5 className="p-0">{t("Cover From Date")}</h5>
                      <p>{details.effectiveDt}</p>
                    </div>
                    <div className="col-md-6 mt-1">
                      <h5 className="p-0">{t("Cover To Date")}</h5>
                      <p>{details.expirationDt}</p>
                    </div>
                    <div className="col-md-12 mt-1">
                      <h5 className="p-0">{t("Product")}</h5>
                      <p>{details.prodId}</p>
                    </div>
                  </div>

                  <div className=" p-0">
                    <h5 className=" mt-1 ">{t("Select Plan")}</h5>

                    <div className="row ">
                      {
                      details?.packageDetails.length>0?
                      details?.packageDetails?.map((item, index) => (
                        <div key={index} className="col-md-12 mt-3">
                          <button
                            className="col-md-12"
                            style={{
                              border: "1px solid #3fd2f2",
                              backgroundColor:
                                activeButton === index ? "#3fd2f2" : "white",
                              color:
                                activeButton === index ? "white" : "#3fd2f2",
                            }}
                            onClick={() => handleClick(index)}
                          >
                            <div className="d-md-flex justify-content-md-between p-0">
                              <div>{item.planSelection}
                                 &nbsp;
                         &nbsp;
                        <span style={{position:"relative",top:"3px", cursor: "pointer"}}
                         onMouseEnter={(e) => handleHoverObtainCvr(e,item.obtainedCvr)}
                  onMouseLeave={handleLeave}
                        ><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-info-circle" viewBox="0 0 16 16">
  <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16"/>
  <path d="m8.93 6.588-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 0-.375-.193-.304-.533zM9 4.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0"/>
</svg></span>
                              </div>
                              <div
                                style={{ fontWeight: "bolder", color: "black" }}
                              >
                                OMR {item.premiumAmt}
                              </div>
                            </div>
                            
                          </button>
                        </div>
                      )):
                      <>
                      <div className="col-md-12 mt-3">
                          <button
                            className="col-md-12"
                            style={{
                              border: "1px solid #3fd2f2",
                              backgroundColor:"#3fd2f2",
                              color: "white",
                            }}
                            onClick={() => {debugger;  handleClickSingleOption(1,details)}}
                          >
                            <div className="d-md-flex justify-content-md-between p-0">
                              <div>{details?.packageDetails.planSelection || details.planSelection || "N/A"}   &nbsp;
                         &nbsp;
                        <span style={{position:"relative",top:"3px", cursor: "pointer"}}
                         onMouseEnter={(e) => handleHoverObtainCvr(e,details?.packageDetails?.obtainedCvr ||  details?.obtainedCvr)}
                  onMouseLeave={handleLeave}
                        ><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-info-circle" viewBox="0 0 16 16">
  <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16"/>
  <path d="m8.93 6.588-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 0-.375-.193-.304-.533zM9 4.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0"/>
</svg></span></div>
                              <div
                                style={{ fontWeight: "bolder", color: "black" }}
                              >
                                OMR {details?.packageDetails.premiumAmt || details?.premiumAmt }
                              </div>
                            </div>
                           
                          </button>
                        </div>
                      </>
                    }

                      {/* {activeButton >= 0 && (
                        <div
                          className="col-md-12 mt-3"
                          style={{ fontSize: "12px" }}
                        >
                          <input
                            type="checkbox"
                            name="checkBox"
                            checked={isChecked}
                            onChange={(e) => {
                              const checked = e.target.checked;
                              setIsChecked(checked);

                              // clear error if checked
                              if (checked) {
                                setErrors((prev) => ({
                                  ...prev,
                                  checkBox: "",
                                }));
                              } else {
                                setErrors((prev) => ({
                                  ...prev,
                                  checkBox: "accept is required",
                                }));
                              }
                            }}
                            onBlur={handleValidation}
                          />{" "}
                          I accept the privacy policy
                          {errors.checkBox && (
                            <span
                              style={{
                                color: "red",
                                fontSize: "10px",
                                marginLeft: "5px",
                              }}
                            >
                              ({errors.checkBox})
                            </span>
                          )}
                        </div>
                      )} */}
                    </div>

                  { activeButton>=0 &&  <div className="row">
                      <div className="col-md-12 mt-3">
                              <div><b>{t("Benefits Covered")} : </b>{formData.obtainedCover}</div>

</div>                      </div>}
                  </div>
                </div>
                {activeButton >= 0 && (
                  <div className=" border  rounded d-flex flex-wrap justify-content-between align-items-center mt-2 p-3">
                    <div className=" p-0">
                      <div className=" p-0 d-flex flex-wrap">
                        <span className="mb-0  p-0 ">{t("NET PREMIUM")}</span>
                        <span>{t("(including VAT & all other taxes)")}</span>
                      </div>

                      <h3>
                        OMR{" "}
                      {formData?.premiumAmount}
                      </h3>
                    </div>
                    <div className="">
                      <button className=" btn btn-primary" onClick={handlePay}>
                        {t("PAY PREMIUM")}
                      </button>
                    </div>
                  </div>
                )}
              </div>
            </div>
          )}
        </div>
      </div>

      <Footer />
      </>
      }

      {showTooltip && (
        <div
          style={{
            position: "fixed",
            top: tooltipPos.y,
            left: tooltipPos.x,
            backgroundColor: "white",
            border: "1px solid #949494ff",
            // color:"white",
            padding: "8px",
            borderRadius: "5px",
            boxShadow: "0px 2px 8px rgba(0,0,0,0.15)",
            zIndex: 9999,
            maxWidth: "450px",
          }}
          
        >
          <ul style={{ margin: 0, paddingLeft: "20px" }}>
            {hoveredCovers.map((cvr, i) => (
              <li key={i}>{cvr.trim()}</li>
            ))}
          </ul>
        </div>
      )}
    
      {loading && (
        <div className="overlay">
          <div className="spinner"></div>
        </div>
      )}
    </>
  );
};

export default MotorInsQuoteSummary;
